// extracted by mini-css-extract-plugin
module.exports = {"container":"_25e8741","listContainer":"_2b463403","footer":"_5ab90763","preferencesLink":"_56d1aeee","sorryMessage":"_356c68c8"};